//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by a tool.
//
//
//       bebopc version:
//           3.0.14
//
//
//       bebopc source:
//           https://github.com/betwixt-labs/bebop
//
//
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.
// </auto-generated>
import { BebopView, BebopRuntimeError, BebopRecord, BebopJson, BebopTypeGuard, Guid, GuidMap } from "bebop";

export const BEBOP_SCHEMA = new Uint8Array([
3, 6, 0, 0, 0, 66, 117, 115, 105, 110, 101, 115, 115, 68,
97, 116, 97, 0, 1, 0, 0, 4, 0, 0, 0, 0, 1, 100, 97, 116,
97, 0, 242, 255, 255, 255, 0, 1, 0, 0, 0, 0, 66, 117, 115,
105, 110, 101, 115, 115, 80, 97, 116, 116, 101, 114, 110,
0, 1, 0, 0, 12, 0, 0, 0, 0, 3, 110, 97, 109, 101, 0, 245,
255, 255, 255, 0, 109, 105, 108, 101, 115, 116, 111, 110,
101, 95, 101, 120, 112, 114, 0, 245, 255, 255, 255, 0,
108, 101, 118, 101, 108, 115, 0, 242, 255, 255, 255, 0, 2,
0, 0, 0, 0, 66, 117, 115, 105, 110, 101, 115, 115, 76,
101, 118, 101, 108, 68, 97, 116, 97, 0, 1, 0, 0, 20, 0, 0,
0, 0, 5, 108, 101, 118, 101, 108, 0, 251, 255, 255, 255,
0, 109, 97, 120, 67, 111, 108, 108, 101, 99, 116, 0, 251,
255, 255, 255, 0, 101, 97, 114, 110, 0, 245, 255, 255,
255, 0, 99, 111, 115, 116, 0, 245, 255, 255, 255, 0, 116,
105, 109, 101, 0, 251, 255, 255, 255, 0, 68, 105, 115,
116, 114, 105, 99, 116, 68, 97, 116, 97, 0, 1, 0, 0, 4, 0,
0, 0, 0, 1, 100, 97, 116, 97, 0, 242, 255, 255, 255, 0, 4,
0, 0, 0, 0, 68, 105, 115, 116, 114, 105, 99, 116, 80, 97,
116, 116, 101, 114, 110, 0, 1, 0, 0, 8, 0, 0, 0, 0, 2,
110, 97, 109, 101, 0, 245, 255, 255, 255, 0, 108, 101,
118, 101, 108, 115, 0, 242, 255, 255, 255, 0, 5, 0, 0, 0,
0, 68, 105, 115, 116, 114, 105, 99, 116, 76, 101, 118,
101, 108, 68, 97, 116, 97, 0, 1, 0, 0, 16, 0, 0, 0, 1, 4,
108, 101, 118, 101, 108, 0, 251, 255, 255, 255, 0, 101,
120, 112, 0, 251, 255, 255, 255, 0, 103, 101, 109, 0, 251,
255, 255, 255, 0, 109, 117, 108, 116, 105, 112, 108, 105,
101, 114, 0, 251, 255, 255, 255, 0, 0, 0, 0, 0
]);


export interface IBusinessData extends BebopRecord {

  readonly data: Array<IBusinessPattern>;
}

export class BusinessData implements IBusinessData {
  public readonly data: Array<IBusinessPattern>;

  constructor(record: IBusinessData) {
    this.data = record.data;
  }

  /**
   * Serializes the current instance into a JSON-Over-Bebop string
   */
  public stringify(): string {
    return BusinessData.encodeToJSON(this);
  }

  /**
   * Serializes the specified object into a JSON-Over-Bebop string
   */
  public static encodeToJSON(record: IBusinessData): string {
    return JSON.stringify(record, BebopJson.replacer);
  }

  /**
   * Validates that the runtime types of members in the current instance are correct.
   */
  public validateTypes(): void {
    BusinessData.validateCompatibility(this);
  }

  /**
   * Validates that the specified dynamic object can become an instance of {@link BusinessData}.
   */
  public static validateCompatibility(record: IBusinessData): void {
    BebopTypeGuard.ensureArray(record.data, BusinessPattern.validateCompatibility);
  }

  /**
   * Unsafely creates an instance of {@link BusinessData} from the specified dynamic object. No type checking is performed.
   */
  public static unsafeCast(record: any): IBusinessData {
      return new BusinessData(record);
  }

  /**
   * Creates a new {@link BusinessData} instance from a JSON-Over-Bebop string. Type checking is performed.
   */
  public static fromJSON(json: string): IBusinessData {
    if (typeof json !== 'string' || json.trim().length === 0) {
      throw new BebopRuntimeError(`BusinessData.fromJSON: expected string`);
    }
    const parsed = JSON.parse(json, BebopJson.reviver);
    BusinessData.validateCompatibility(parsed);
    return BusinessData.unsafeCast(parsed);
  }
  public encode(): Uint8Array {
    return BusinessData.encode(this);
  }

  public static encode(record: IBusinessData): Uint8Array {
    const view = BebopView.getInstance();
    view.startWriting();
    BusinessData.encodeInto(record, view);
    return view.toArray();
  }

  public static encodeInto(record: IBusinessData, view: BebopView): number {
    const before = view.length;
    {
      const length0 = record.data.length;
      view.writeUint32(length0);
      for (let i0 = 0; i0 < length0; i0++) {
        BusinessPattern.encodeInto(record.data[i0], view)
      }
    }
    const after = view.length;
    return after - before;
  }

  public static decode(buffer: Uint8Array): IBusinessData {
    const view = BebopView.getInstance();
    view.startReading(buffer);
    return BusinessData.readFrom(view);
  }

  public static readFrom(view: BebopView): IBusinessData {
    let field0: Array<IBusinessPattern>;
    {
      let length0 = view.readUint32();
      field0 = new Array<IBusinessPattern>(length0);
      for (let i0 = 0; i0 < length0; i0++) {
        let x0: IBusinessPattern;
        x0 = BusinessPattern.readFrom(view);
        field0[i0] = x0;
      }
    }
    let message: IBusinessData = {
      data: field0,
    };
    return new BusinessData(message);
  }
}


export interface IBusinessPattern extends BebopRecord {

  readonly name: string;

  readonly milestoneExpr: string;

  readonly levels: Array<IBusinessLevelData>;
}

export class BusinessPattern implements IBusinessPattern {
  public readonly name: string;
  public readonly milestoneExpr: string;
  public readonly levels: Array<IBusinessLevelData>;

  constructor(record: IBusinessPattern) {
    this.name = record.name;
    this.milestoneExpr = record.milestoneExpr;
    this.levels = record.levels;
  }

  /**
   * Serializes the current instance into a JSON-Over-Bebop string
   */
  public stringify(): string {
    return BusinessPattern.encodeToJSON(this);
  }

  /**
   * Serializes the specified object into a JSON-Over-Bebop string
   */
  public static encodeToJSON(record: IBusinessPattern): string {
    return JSON.stringify(record, BebopJson.replacer);
  }

  /**
   * Validates that the runtime types of members in the current instance are correct.
   */
  public validateTypes(): void {
    BusinessPattern.validateCompatibility(this);
  }

  /**
   * Validates that the specified dynamic object can become an instance of {@link BusinessPattern}.
   */
  public static validateCompatibility(record: IBusinessPattern): void {
    BebopTypeGuard.ensureString(record.name)
    BebopTypeGuard.ensureString(record.milestoneExpr)
    BebopTypeGuard.ensureArray(record.levels, BusinessLevelData.validateCompatibility);
  }

  /**
   * Unsafely creates an instance of {@link BusinessPattern} from the specified dynamic object. No type checking is performed.
   */
  public static unsafeCast(record: any): IBusinessPattern {
      return new BusinessPattern(record);
  }

  /**
   * Creates a new {@link BusinessPattern} instance from a JSON-Over-Bebop string. Type checking is performed.
   */
  public static fromJSON(json: string): IBusinessPattern {
    if (typeof json !== 'string' || json.trim().length === 0) {
      throw new BebopRuntimeError(`BusinessPattern.fromJSON: expected string`);
    }
    const parsed = JSON.parse(json, BebopJson.reviver);
    BusinessPattern.validateCompatibility(parsed);
    return BusinessPattern.unsafeCast(parsed);
  }
  public encode(): Uint8Array {
    return BusinessPattern.encode(this);
  }

  public static encode(record: IBusinessPattern): Uint8Array {
    const view = BebopView.getInstance();
    view.startWriting();
    BusinessPattern.encodeInto(record, view);
    return view.toArray();
  }

  public static encodeInto(record: IBusinessPattern, view: BebopView): number {
    const before = view.length;
    view.writeString(record.name);
    view.writeString(record.milestoneExpr);
    {
      const length0 = record.levels.length;
      view.writeUint32(length0);
      for (let i0 = 0; i0 < length0; i0++) {
        BusinessLevelData.encodeInto(record.levels[i0], view)
      }
    }
    const after = view.length;
    return after - before;
  }

  public static decode(buffer: Uint8Array): IBusinessPattern {
    const view = BebopView.getInstance();
    view.startReading(buffer);
    return BusinessPattern.readFrom(view);
  }

  public static readFrom(view: BebopView): IBusinessPattern {
    let field0: string;
    field0 = view.readString();
    let field1: string;
    field1 = view.readString();
    let field2: Array<IBusinessLevelData>;
    {
      let length0 = view.readUint32();
      field2 = new Array<IBusinessLevelData>(length0);
      for (let i0 = 0; i0 < length0; i0++) {
        let x0: IBusinessLevelData;
        x0 = BusinessLevelData.readFrom(view);
        field2[i0] = x0;
      }
    }
    let message: IBusinessPattern = {
      name: field0,
      milestoneExpr: field1,
      levels: field2,
    };
    return new BusinessPattern(message);
  }
}


export interface IBusinessLevelData extends BebopRecord {

  readonly level: number;

  readonly maxCollect: number;

  readonly earn: string;

  readonly cost: string;

  readonly time: number;
}

export class BusinessLevelData implements IBusinessLevelData {
  public readonly level: number;
  public readonly maxCollect: number;
  public readonly earn: string;
  public readonly cost: string;
  public readonly time: number;

  constructor(record: IBusinessLevelData) {
    this.level = record.level;
    this.maxCollect = record.maxCollect;
    this.earn = record.earn;
    this.cost = record.cost;
    this.time = record.time;
  }

  /**
   * Serializes the current instance into a JSON-Over-Bebop string
   */
  public stringify(): string {
    return BusinessLevelData.encodeToJSON(this);
  }

  /**
   * Serializes the specified object into a JSON-Over-Bebop string
   */
  public static encodeToJSON(record: IBusinessLevelData): string {
    return JSON.stringify(record, BebopJson.replacer);
  }

  /**
   * Validates that the runtime types of members in the current instance are correct.
   */
  public validateTypes(): void {
    BusinessLevelData.validateCompatibility(this);
  }

  /**
   * Validates that the specified dynamic object can become an instance of {@link BusinessLevelData}.
   */
  public static validateCompatibility(record: IBusinessLevelData): void {
    BebopTypeGuard.ensureUint32(record.level)
    BebopTypeGuard.ensureUint32(record.maxCollect)
    BebopTypeGuard.ensureString(record.earn)
    BebopTypeGuard.ensureString(record.cost)
    BebopTypeGuard.ensureUint32(record.time)
  }

  /**
   * Unsafely creates an instance of {@link BusinessLevelData} from the specified dynamic object. No type checking is performed.
   */
  public static unsafeCast(record: any): IBusinessLevelData {
      return new BusinessLevelData(record);
  }

  /**
   * Creates a new {@link BusinessLevelData} instance from a JSON-Over-Bebop string. Type checking is performed.
   */
  public static fromJSON(json: string): IBusinessLevelData {
    if (typeof json !== 'string' || json.trim().length === 0) {
      throw new BebopRuntimeError(`BusinessLevelData.fromJSON: expected string`);
    }
    const parsed = JSON.parse(json, BebopJson.reviver);
    BusinessLevelData.validateCompatibility(parsed);
    return BusinessLevelData.unsafeCast(parsed);
  }
  public encode(): Uint8Array {
    return BusinessLevelData.encode(this);
  }

  public static encode(record: IBusinessLevelData): Uint8Array {
    const view = BebopView.getInstance();
    view.startWriting();
    BusinessLevelData.encodeInto(record, view);
    return view.toArray();
  }

  public static encodeInto(record: IBusinessLevelData, view: BebopView): number {
    const before = view.length;
    view.writeUint32(record.level);
    view.writeUint32(record.maxCollect);
    view.writeString(record.earn);
    view.writeString(record.cost);
    view.writeUint32(record.time);
    const after = view.length;
    return after - before;
  }

  public static decode(buffer: Uint8Array): IBusinessLevelData {
    const view = BebopView.getInstance();
    view.startReading(buffer);
    return BusinessLevelData.readFrom(view);
  }

  public static readFrom(view: BebopView): IBusinessLevelData {
    let field0: number;
    field0 = view.readUint32();
    let field1: number;
    field1 = view.readUint32();
    let field2: string;
    field2 = view.readString();
    let field3: string;
    field3 = view.readString();
    let field4: number;
    field4 = view.readUint32();
    let message: IBusinessLevelData = {
      level: field0,
      maxCollect: field1,
      earn: field2,
      cost: field3,
      time: field4,
    };
    return new BusinessLevelData(message);
  }
}


export interface IDistrictData extends BebopRecord {

  readonly data: Array<IDistrictPattern>;
}

export class DistrictData implements IDistrictData {
  public readonly data: Array<IDistrictPattern>;

  constructor(record: IDistrictData) {
    this.data = record.data;
  }

  /**
   * Serializes the current instance into a JSON-Over-Bebop string
   */
  public stringify(): string {
    return DistrictData.encodeToJSON(this);
  }

  /**
   * Serializes the specified object into a JSON-Over-Bebop string
   */
  public static encodeToJSON(record: IDistrictData): string {
    return JSON.stringify(record, BebopJson.replacer);
  }

  /**
   * Validates that the runtime types of members in the current instance are correct.
   */
  public validateTypes(): void {
    DistrictData.validateCompatibility(this);
  }

  /**
   * Validates that the specified dynamic object can become an instance of {@link DistrictData}.
   */
  public static validateCompatibility(record: IDistrictData): void {
    BebopTypeGuard.ensureArray(record.data, DistrictPattern.validateCompatibility);
  }

  /**
   * Unsafely creates an instance of {@link DistrictData} from the specified dynamic object. No type checking is performed.
   */
  public static unsafeCast(record: any): IDistrictData {
      return new DistrictData(record);
  }

  /**
   * Creates a new {@link DistrictData} instance from a JSON-Over-Bebop string. Type checking is performed.
   */
  public static fromJSON(json: string): IDistrictData {
    if (typeof json !== 'string' || json.trim().length === 0) {
      throw new BebopRuntimeError(`DistrictData.fromJSON: expected string`);
    }
    const parsed = JSON.parse(json, BebopJson.reviver);
    DistrictData.validateCompatibility(parsed);
    return DistrictData.unsafeCast(parsed);
  }
  public encode(): Uint8Array {
    return DistrictData.encode(this);
  }

  public static encode(record: IDistrictData): Uint8Array {
    const view = BebopView.getInstance();
    view.startWriting();
    DistrictData.encodeInto(record, view);
    return view.toArray();
  }

  public static encodeInto(record: IDistrictData, view: BebopView): number {
    const before = view.length;
    {
      const length0 = record.data.length;
      view.writeUint32(length0);
      for (let i0 = 0; i0 < length0; i0++) {
        DistrictPattern.encodeInto(record.data[i0], view)
      }
    }
    const after = view.length;
    return after - before;
  }

  public static decode(buffer: Uint8Array): IDistrictData {
    const view = BebopView.getInstance();
    view.startReading(buffer);
    return DistrictData.readFrom(view);
  }

  public static readFrom(view: BebopView): IDistrictData {
    let field0: Array<IDistrictPattern>;
    {
      let length0 = view.readUint32();
      field0 = new Array<IDistrictPattern>(length0);
      for (let i0 = 0; i0 < length0; i0++) {
        let x0: IDistrictPattern;
        x0 = DistrictPattern.readFrom(view);
        field0[i0] = x0;
      }
    }
    let message: IDistrictData = {
      data: field0,
    };
    return new DistrictData(message);
  }
}


export interface IDistrictPattern extends BebopRecord {

  readonly name: string;

  readonly levels: Array<IDistrictLevelData>;
}

export class DistrictPattern implements IDistrictPattern {
  public readonly name: string;
  public readonly levels: Array<IDistrictLevelData>;

  constructor(record: IDistrictPattern) {
    this.name = record.name;
    this.levels = record.levels;
  }

  /**
   * Serializes the current instance into a JSON-Over-Bebop string
   */
  public stringify(): string {
    return DistrictPattern.encodeToJSON(this);
  }

  /**
   * Serializes the specified object into a JSON-Over-Bebop string
   */
  public static encodeToJSON(record: IDistrictPattern): string {
    return JSON.stringify(record, BebopJson.replacer);
  }

  /**
   * Validates that the runtime types of members in the current instance are correct.
   */
  public validateTypes(): void {
    DistrictPattern.validateCompatibility(this);
  }

  /**
   * Validates that the specified dynamic object can become an instance of {@link DistrictPattern}.
   */
  public static validateCompatibility(record: IDistrictPattern): void {
    BebopTypeGuard.ensureString(record.name)
    BebopTypeGuard.ensureArray(record.levels, DistrictLevelData.validateCompatibility);
  }

  /**
   * Unsafely creates an instance of {@link DistrictPattern} from the specified dynamic object. No type checking is performed.
   */
  public static unsafeCast(record: any): IDistrictPattern {
      return new DistrictPattern(record);
  }

  /**
   * Creates a new {@link DistrictPattern} instance from a JSON-Over-Bebop string. Type checking is performed.
   */
  public static fromJSON(json: string): IDistrictPattern {
    if (typeof json !== 'string' || json.trim().length === 0) {
      throw new BebopRuntimeError(`DistrictPattern.fromJSON: expected string`);
    }
    const parsed = JSON.parse(json, BebopJson.reviver);
    DistrictPattern.validateCompatibility(parsed);
    return DistrictPattern.unsafeCast(parsed);
  }
  public encode(): Uint8Array {
    return DistrictPattern.encode(this);
  }

  public static encode(record: IDistrictPattern): Uint8Array {
    const view = BebopView.getInstance();
    view.startWriting();
    DistrictPattern.encodeInto(record, view);
    return view.toArray();
  }

  public static encodeInto(record: IDistrictPattern, view: BebopView): number {
    const before = view.length;
    view.writeString(record.name);
    {
      const length0 = record.levels.length;
      view.writeUint32(length0);
      for (let i0 = 0; i0 < length0; i0++) {
        DistrictLevelData.encodeInto(record.levels[i0], view)
      }
    }
    const after = view.length;
    return after - before;
  }

  public static decode(buffer: Uint8Array): IDistrictPattern {
    const view = BebopView.getInstance();
    view.startReading(buffer);
    return DistrictPattern.readFrom(view);
  }

  public static readFrom(view: BebopView): IDistrictPattern {
    let field0: string;
    field0 = view.readString();
    let field1: Array<IDistrictLevelData>;
    {
      let length0 = view.readUint32();
      field1 = new Array<IDistrictLevelData>(length0);
      for (let i0 = 0; i0 < length0; i0++) {
        let x0: IDistrictLevelData;
        x0 = DistrictLevelData.readFrom(view);
        field1[i0] = x0;
      }
    }
    let message: IDistrictPattern = {
      name: field0,
      levels: field1,
    };
    return new DistrictPattern(message);
  }
}


export interface IDistrictLevelData extends BebopRecord {

  readonly level: number;

  readonly exp: number;

  readonly gem: number;

  readonly multiplier: number;
}

export class DistrictLevelData implements IDistrictLevelData {
  public readonly level: number;
  public readonly exp: number;
  public readonly gem: number;
  public readonly multiplier: number;

  constructor(record: IDistrictLevelData) {
    this.level = record.level;
    this.exp = record.exp;
    this.gem = record.gem;
    this.multiplier = record.multiplier;
  }

  /**
   * Serializes the current instance into a JSON-Over-Bebop string
   */
  public stringify(): string {
    return DistrictLevelData.encodeToJSON(this);
  }

  /**
   * Serializes the specified object into a JSON-Over-Bebop string
   */
  public static encodeToJSON(record: IDistrictLevelData): string {
    return JSON.stringify(record, BebopJson.replacer);
  }

  /**
   * Validates that the runtime types of members in the current instance are correct.
   */
  public validateTypes(): void {
    DistrictLevelData.validateCompatibility(this);
  }

  /**
   * Validates that the specified dynamic object can become an instance of {@link DistrictLevelData}.
   */
  public static validateCompatibility(record: IDistrictLevelData): void {
    BebopTypeGuard.ensureUint32(record.level)
    BebopTypeGuard.ensureUint32(record.exp)
    BebopTypeGuard.ensureUint32(record.gem)
    BebopTypeGuard.ensureUint32(record.multiplier)
  }

  /**
   * Unsafely creates an instance of {@link DistrictLevelData} from the specified dynamic object. No type checking is performed.
   */
  public static unsafeCast(record: any): IDistrictLevelData {
      return new DistrictLevelData(record);
  }

  /**
   * Creates a new {@link DistrictLevelData} instance from a JSON-Over-Bebop string. Type checking is performed.
   */
  public static fromJSON(json: string): IDistrictLevelData {
    if (typeof json !== 'string' || json.trim().length === 0) {
      throw new BebopRuntimeError(`DistrictLevelData.fromJSON: expected string`);
    }
    const parsed = JSON.parse(json, BebopJson.reviver);
    DistrictLevelData.validateCompatibility(parsed);
    return DistrictLevelData.unsafeCast(parsed);
  }
  public encode(): Uint8Array {
    return DistrictLevelData.encode(this);
  }

  public static encode(record: IDistrictLevelData): Uint8Array {
    const view = BebopView.getInstance();
    view.startWriting();
    DistrictLevelData.encodeInto(record, view);
    return view.toArray();
  }

  public static encodeInto(record: IDistrictLevelData, view: BebopView): number {
    const before = view.length;
    view.writeUint32(record.level);
    view.writeUint32(record.exp);
    view.writeUint32(record.gem);
    view.writeUint32(record.multiplier);
    const after = view.length;
    return after - before;
  }

  public static decode(buffer: Uint8Array): IDistrictLevelData {
    const view = BebopView.getInstance();
    view.startReading(buffer);
    return DistrictLevelData.readFrom(view);
  }

  public static readFrom(view: BebopView): IDistrictLevelData {
    let field0: number;
    field0 = view.readUint32();
    let field1: number;
    field1 = view.readUint32();
    let field2: number;
    field2 = view.readUint32();
    let field3: number;
    field3 = view.readUint32();
    let message: IDistrictLevelData = {
      level: field0,
      exp: field1,
      gem: field2,
      multiplier: field3,
    };
    return new DistrictLevelData(message);
  }
}

